<template>
    <error-message
        :message="message"
        :field-name="fieldName"
    />
</template>

<script>
import ErrorMessage from './ErrorMessage.vue';
import ResourceMixin from '@core/Util/Mixins/resources'

export default {
    name: "value-must-be-equal-or-greater-error-message",
    
    mixins: [ResourceMixin],
    
    components: {
        ErrorMessage
    },

    props: {
        fieldName: {
            type: String,
            required: true
        },
        otherFieldName: {
            type: String,
            required: true
        }
    },
    
    computed: {
        message(){
            const vm = this;

            //Value must be equal or greater than {1}.
            const baseMessage = vm.resource('Shared_Error_ValueMustBeEqualOrGreater').replace('{1}', vm.otherFieldName);
            return `${vm.fieldName}: ${baseMessage}`
        }
    }
}
</script>
